import { Descendant } from 'slate';
import { useSlate } from 'slate-react';
import { twMerge } from 'tailwind-merge';
import { Tooltip } from 'ui';
import { IconButton } from 'ui/atoms';

import { ElementType } from '../types';
import { isBlockActive, toggleBlock } from '../utils';

export type ListItemElement = { type: 'list-item'; children: Descendant[] };

type BlockButtonProps = {
  format: ElementType;
  icon: JSX.Element;
  title: string;
  withTitle?: boolean;
};

const BlockButton = ({ format, icon, title, withTitle }: BlockButtonProps) => {
  const editor = useSlate();

  return (
    <Tooltip title={withTitle ? '' : title} placement="top">
      <IconButton
        className={twMerge(
          'flex items-center justify-center w-9 h-9 hover:bg-transparent active:bg-v2blueGray-100',
          isBlockActive(editor, format) && 'bg-v2blueGray-100 hover:bg-v2blueGray-100',
        )}
        onMouseDown={(event) => {
          event.preventDefault();
          toggleBlock(editor, format);
        }}
      >
        {icon}
      </IconButton>
    </Tooltip>
  );
};

export { BlockButton };
